<template>
    <button @click="modal = !modal" class="btn btn-sm btn-danger">
        <img src="../../../assets/trash-can.svg" width="15" alt="">
    </button>
    <div v-if="modal" class="modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Borrar</h5>
                <button @click="modal = !modal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p>
                    <b>La categoria: </b>{{nic_props.title}} 
                    <b>con el Id :</b> {{nic_props.id}} será borrado
                </p>
               <!-- <pre>
                {{nic_props}}
               </pre> -->
            </div>
            <div class="modal-footer">
                <button @click="modal = !modal" type="button" class="btn btn-secondary" data-bs-dismiss="modal">cancelar</button>
                <button @click="delete_nic" type="button" class="btn btn-warning">Eliminar</button>
            </div>
            </div>
        </div>
    </div>




</template>
<script>
    import {ref} from 'vue'
    //import axios from 'axios'
    //import { useStore } from 'vuex' 
    //import { useToast } from 'vue-toastification'
    
    export default {
        name:'nicDelete',
        props:['nic_props'],
        setup(props){
            //const store = useStore()
            //const toast = useToast()
            
            const modal = ref(false)
            const delete_nic = () =>{
                console.log(props.nic_props)
            }
            return{
                delete_nic,
                modal
            }
        }
    }



</script>